export const CancellationUtil = {
  isNotVVGOnlyOrOneProductSelected(form) {
    return Object.values(form).some(product => {
      if (product.preInsurer) return true
      if (product.preInsurerVvgs) {
        return product.preInsurerVvgs.some(vvg => vvg.cancellationExisting)
      }
      return false
    })
  },

  createPreInsurerVvg(cancellationDate, cancellationExisting = false) {
    return {
      cancellationExisting,
      preInsurerId: null,
      cancellationDate,
      preInsurerCustomerNumber: null,
      cancelAllProducts: null,
      products: null,
    }
  },

  hasEmptyPreInsurer(personPreInsurerVvgs) {
    return personPreInsurerVvgs.length === 1 && personPreInsurerVvgs.every(p => p.cancellationExisting === false)
  },

  mapQuestionsToPerson(questions) {
    return questions.reduce((acc, q) => {
      acc[q.personId] = {
        kvg: q.kvg,
        vvg: q.vvg,
      }
      return acc
    }, {})
  },
}
